import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {ScrollingBarModule} from '../scrolling-bar';
import {CustomScrollbarComponent} from './custom-scrollbar.component';
import {CustomScrollbarService} from './custom-scrollbar.service';

@NgModule({
    imports: [
        CommonModule,
        ScrollingBarModule
    ],
    declarations: [
        CustomScrollbarComponent
    ],
    exports: [
        CustomScrollbarComponent
    ],
    providers: [
        CustomScrollbarService
    ]
})
export class CustomScrollbarModule {}
